module.exports = __webpack_public_path__ + "img/chuangke2.fee81afb.jpg";